export { Input, type InputProps } from "./Input.component";
